import { CALL_API } from '../../../middleware/api';
import { cart } from '../../../schema';
import { decamelizeKeys } from 'humps';

const LOAD = 'cart/LOAD';
const LOAD_SUCESS = 'cart/LOAD_SUCESS';
const LOAD_FAIL = 'cart/LOAD_FAIL';

const ADD_ROW = 'cart/ADD_ROW';
const ADD_ROW_SUCCESS = 'cart/ADD_ROW_SUCCESS';
const ADD_ROW_FAIL = 'cart/ADD_ROW_FAIL';

const REMOVE_ROW = 'cart/REMOVE_ROW';
const REMOVE_ROW_SUCCESS = 'cart/REMOVE_ROW_SUCCESS';
const REMOVE_ROW_FAIL = 'cart/REMOVE_ROW_FAIL';

const CHECKOUT = 'cart/CHECKOUT';
const CHECKOUT_SUCCESS = 'cart/CHECKOUT_SUCCESS';
const CHECKOUT_FAIL = 'cart/CHECKOUT_FAIL';

const OPEN = 'cart/OPEN';
const CLOSE = 'cart/CLOSE';

export const openCart = _ => ({
  type: OPEN
});

export const closeCart = _ => ({
  type: CLOSE
});


export const loadCart = _ => (dispatch, getState) => {
  const { id } = getState().user.company;
  return dispatch({
    [CALL_API]: {
      types: [LOAD, LOAD_SUCESS, LOAD_FAIL],
      endpoint: `cart/${id}/`,
      method: 'GET',
      schema: cart,
      skipAdd: true
    }
  });
};


export const removeRow = rowId => (dispatch, getState) => {
  const { id } = getState().user.company;
  return dispatch({
    [CALL_API]: {
      types: [REMOVE_ROW, REMOVE_ROW_SUCCESS, REMOVE_ROW_FAIL],
      endpoint: `cart/${id}/row/${rowId}/`,
      method: 'DELETE',
      schema: cart,
      skipAdd: true
    }
  });
};


export const addRow = row => (dispatch, getState) => {
  const { id } = getState().user.company;
  return dispatch({
    [CALL_API]: {
      types: [ADD_ROW, ADD_ROW_SUCCESS, ADD_ROW_FAIL],
      endpoint: `cart/${id}/row/`,
      method: 'POST',
      payload: decamelizeKeys(row),
      schema: cart,
      skipAdd: true
    }  
  }).then(_ => { dispatch(openCart());});
};


export const checkout = payload => (dispatch, getState) => {
  const { id } = getState().user.company;

  return dispatch({
    [CALL_API]: {
      types: [CHECKOUT, CHECKOUT_SUCCESS, CHECKOUT_FAIL],
      method: 'POST',
      endpoint: `cart/${id}/checkout/`,
      payload
    }
  }).then(s => dispatch(loadCart())) // Fetch fresh cart
};


const initialState = {
  open: false,
  cart: {},
  products: {},
  cartItem: {},
  result: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case OPEN:
      return {...state, open: true}

    case CLOSE:
      return {...state, open: false}

    case LOAD_SUCESS:
    case ADD_ROW_SUCCESS:
    case REMOVE_ROW_SUCCESS:
      return {...state, ...action.response.entities}

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/cart/index.js